import ImageConverterTemplate from "../components/ImageConverterTemplate";

export default function ConvertWebpToTiff() {
  return (
    <ImageConverterTemplate
      sourceFormat="WebP"
      targetFormat="TIFF"
      acceptTypes=".webp,image/webp"
      slug="convert-webp-to-tiff"
      gradientColors="from-green-500 to-purple-500"
      accentColor="purple"
    />
  );
}
